<button type="button" [id]="question.getPanelRemoveButtonId(panel)" (click)="removePanelClick()" [disabled]="!isActionEnabled" [class]="question.getPanelRemoveButtonCss()"> 
  <span [class]="question.cssClasses.buttonRemoveText"><sv-ng-string [model]="question.locRemovePanelText"></sv-ng-string></span>
  <span [class]="question.cssClasses.iconRemove"></span>
</button>
